import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { TaskInstance } from '@web/shiftTasks/types/TaskInstance';
import { getShiftTaskDetailsQueryKey } from '@web/shiftTasks/utils/getQueryKey';
import { SubtaskInstance } from '@web/shiftTasks/types/SubtaskIntance';

export const useShiftTaskInstancesQueryCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => {
    const updateShiftTaskInstance = (taskInstance: TaskInstance) => {
      const detailsQueryKey = getShiftTaskDetailsQueryKey(taskInstance.id);

      queryClient.setQueryData<TaskInstance>(detailsQueryKey, () => taskInstance);
    };

    const updateSubtaskInstanceStatus = (taskId: ID, subtaskInstance: SubtaskInstance) => {
      const detailsQueryKey = getShiftTaskDetailsQueryKey(taskId);

      queryClient.setQueryData<TaskInstance>(detailsQueryKey, (cachedTaskInstance) => {
        if (!cachedTaskInstance) {
          return;
        }

        return {
          ...cachedTaskInstance,
          subtasks: cachedTaskInstance.subtasks.map((cachedSubtask) =>
            cachedSubtask.id === subtaskInstance.id ? { ...subtaskInstance } : cachedSubtask
          ),
        };
      });
    };

    return { updateShiftTaskInstance, updateSubtaskInstanceStatus };
  }, [queryClient]);
};
